// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header{background-color:#0747a6}.login-wrap{background:#324157}.plugins-tips{background:#eef1f6}.el-upload--text em,.plugins-tips a{color:#20a0ff}.pure-button{background:#20a0ff}.tags-li.active{border:1px solid #409eff;background-color:#409eff}.message-title{color:#20a0ff}.collapse-btn:hover{background:#283446}", ""]);
// Exports
module.exports = exports;
